import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { UserTeamPickerComponent } from '../Common/User-Pickers/user-team-picker.component';
import { ConsultingEngagementsRepository } from '../Consulting/consultingEngagements.repository';
import {
    ClientServiceType,
    Constants,
    EmptyGuid,
    EntityTypeIDs,
    EntityTypeIds,
    PropertyType,
    PropertyTypeDescription,
    RyanInstanceId,
} from 'src/app/constants.new';
import { AceLoaderComponent } from '../UI-Lib/ACE/Loader/loader.component';
import { AnchorRouteDirective } from '../UI-Lib/Directives';
import { SelectComponent } from '../UI-Lib/Select/select.component';
import { WeissmanDatetimeComponent } from '../UI-Lib/Weiss-Datepicker/weissman-datetime.component';
import { ClientServiceResponsibilityService } from './clientServiceResponsibility.service';
import {
    ClientServiceResponsibility,
    ClientServicesPanelData,
    EntityClientService,
    ClientServicePanelWorkflowUserTypes,
    WorkflowUserTypesUI,
    TransmitDeliveryDetail,
    DRTeamRetrievesDeliveryDetail,
    ComplianceDeliveryDetail,
    DRTeamRetrievesWPDeliveryDetail,
    CSRResponsibilitiesDTOIn,
    DeliveryDetailFeedSpecification,
} from './clientServices.model';
import { InstanceRepository } from '../Entity/Instance/instance.repository';
import { InstanceRights, RestrictData, RestrictService } from '../Common/Permissions/restrict.service';
import { UserInstanceService } from '../User/userInstance.service';
import { ChangeHistoryModalLaunchService } from '../Common/Change-History/changeHistoryModalLaunch.service';
import { CompanyModel, CompanyService } from '../Entity/Company/company.service';
import { NavigationService } from '../Layout/navigation.service';
import { ClientServicesExceptionModalService } from './Exceptions/client-service-exception-modal.service';
import { ToastrService } from 'ngx-toastr';
import { lastValueFrom, Subject, takeUntil } from 'rxjs';
import { CompanyEntity } from '../Entity/entity.model';
import { FeatureFlagsService } from '../Common/FeatureFlags/feature-flags-service';
import { ProcessingService } from '../Processing/processing.service.upgrade';
import { LongRunningProcessRepository } from '../Compliance/Repositories';
import { WebsocketListenerService } from '../Compliance/websocketListener.service';
import { BusyIndicatorModule, BusyIndicatorRef, BusyIndicatorService } from '../Busy-Indicator';
import { TaxFeedSettingRepository } from '../Entity/taxFeedSettingRepository';
import { DocumentIntakeLicensedClientDetailRepository } from '../Documents/Document-Intake-Licensed-Clients/documentIntakeLicensedClient.repository';
import { UserGroupService } from '../User-Group/user-group-service.upgrade';
import { UserService } from '../Account/user.service';
import { TransmittalOutputType } from '../Processing/Transmittal/transmittal.models';
import { TeamService } from '../Team/team.service';
import { DeliveryDetailsAssessmentAllocationComponent } from './Panel/Delivery-Details/deliveryDetailsAssessmentAllocation.component';
import { DeliveryDetailsComplianceReturnsComponent } from './Panel/Delivery-Details/deliveryDetailsComplianceReturns.component';
import { DeliveryDetailsTeamRetrievesComponent } from './Panel/Delivery-Details/deliveryDetailsTeamRetrieves.component';
import { DeliveryDetailsTransmitComponent } from './Panel/Delivery-Details/deliveryDetailsTransmit.component';
import { ParcelService } from '../Entity/Parcel/parcel.service.upgrade';
import { BreadCrumb, BreadCrumbsComponent } from '../UI-Lib/Bread-Crumb/breadCrumbs.component';
import { UIRouter } from '@uirouter/angular';
import { SiteService } from '../Entity/Site/Site.Service.upgrade';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Engagement } from '../Common/Contracts-Invoices/contract-invoices.model';
import { EngagementNumberLookupModalComponent } from '../Common/Contracts-Invoices/engagement-number-lookup-modal.component';

@Component({
    selector: 'client-services',
    templateUrl: 'clientServices.component.html',
    styleUrls: ['clientServices.component.scss'],
    imports: [
        CommonModule,
        FormsModule,
        AceLoaderComponent,
        BusyIndicatorModule,
        UserTeamPickerComponent,
        AnchorRouteDirective,
        WeissmanDatetimeComponent,
        DeliveryDetailsComplianceReturnsComponent,
        DeliveryDetailsTeamRetrievesComponent,
        DeliveryDetailsTransmitComponent,
        SelectComponent,
        DeliveryDetailsAssessmentAllocationComponent,
        BreadCrumbsComponent,
    ],
})
export class ClientServicesComponent implements OnInit, OnDestroy {
    constructor(
        private readonly _consultingEngagementsRepository: ConsultingEngagementsRepository,
        private readonly _instanceRepository: InstanceRepository,
        private readonly _restrictService: RestrictService,
        private readonly _userInstanceService: UserInstanceService,
        private readonly _companyService: CompanyService,
        private readonly _siteService: SiteService,
        private readonly _navigationService: NavigationService,
        private readonly _changeHistoryModalLaunchService: ChangeHistoryModalLaunchService,
        private readonly _toastr: ToastrService,
        private readonly _clientServicesExceptionModalService: ClientServicesExceptionModalService,
        private readonly _featureFlagService: FeatureFlagsService,
        private readonly _csrService: ClientServiceResponsibilityService,
        private readonly _processingService: ProcessingService,
        private readonly _longRunningProcessRepository: LongRunningProcessRepository,
        private readonly _websocketListenerService: WebsocketListenerService,
        private readonly _busyService: BusyIndicatorService,
        private readonly _teamService: TeamService,
        private readonly _taxFeedSettingRepository: TaxFeedSettingRepository,
        private readonly _documentIntakeLicensedClientRepository: DocumentIntakeLicensedClientDetailRepository,
        private readonly _userGroupService: UserGroupService,
        private readonly _userService: UserService,
        private readonly _featureFlagsService: FeatureFlagsService,
        private readonly _parcelService: ParcelService,
        private readonly _constants: Constants,
        private readonly _modalService: BsModalService,
        private readonly _router: UIRouter,
    ) {}

    company: CompanyModel;
    entity: CompanyEntity;

    isCompany: boolean;
    isTopLevelCompany: boolean;
    isParcel: boolean;
    serverAction: boolean;
    enteringEditMode: boolean;
    editMode: boolean;
    loadingDropdownData: boolean;
    panelLoading: boolean = true;
    isLongRunningProcessRunning: boolean;

    entityInstanceId: number;
    isEntityInRyanInstance: boolean;
    topLevelCompanyId: number;
    hasEditPermission: boolean;
    hasComplianceFeatureView: boolean;
    isExplicitView: boolean;
    isConsultantPerspective: boolean;
    consultantsInstanceId: number;
    hasTaxFeeds: boolean;
    canEditCompany: boolean;
    isLicensedDIUser: boolean;
    currentInstanceId: number;

    panelData: ClientServicesPanelData;
    breadcrumbs: BreadCrumb[];
    consultingEngagements: Core.ConsultingEngagementResponse[];
    availableClientServices: Weissman.Model.Workflow.ClientService[];
    newClientService: Weissman.Model.Workflow.ClientService;
    availablePropertyTypes: PropertyTypeDescription[];
    newPropertyType: PropertyTypeDescription;
    ClientServiceType = ClientServiceType;
    entityTree: Core.EntityTree;
    taxFeedSettings: Core.TaxFeedSettingModel;
    topLevelCompanyTaxFeedSettings: Core.TaxFeedSettingModel;
    ahAvailableUsers: Core.UserTeamModel[];
    csrAvailableUsers: Core.UserTeamModel[];
    paymentBatchData: Weissman.Model.DeliveryDetails.DeliveryDetailPaymentBatchDTOIn;
    workflowUserTypes: Compliance.NameValuePair<ClientServicePanelWorkflowUserTypes>[] = [
        { value: Core.WorkflowUserTypes.AccountHandler, name: 'Account Handler' },
        { value: WorkflowUserTypesUI.ConsultingEngagement, name: 'Consultant' },
        { value: Core.WorkflowUserTypes.JurisdictionSpecialist, name: 'Jurisdiction Specialist' },
        { value: Core.WorkflowUserTypes.User, name: 'Specific Individual' },
        { value: Core.WorkflowUserTypes.NA, name: 'N/A' },
        { value: Core.WorkflowUserTypes.ConsultantAccountHandler, name: 'Account Handler' }, //isn't shown as a dropdown option, but is shown for consultants when their account handler is chosen
    ]; //order is intentional

    private _consultingEngagementAccountHandlerTitle: string;
    private _originalPanelData: ClientServicesPanelData;
    private _propertyTypes: PropertyTypeDescription[];
    private _originalPPReturnPreparationAllowed: boolean;
    private readonly COMPLIANCE_PREFIX = 'batch';
    private readonly ALLOCATIONS_PREFIX = 'allocation';
    private _destroy$: Subject<void> = new Subject();
    private _busyDestroy$: Subject<void> = new Subject();
    private _busyRef: BusyIndicatorRef;
    private _instanceLicensedDISettings: Core.DocumentIntakeLicensedClientModel;
    bsModalRef: BsModalRef;

    get accountHandlerTitle(): string {
        //explicit instance access

        if (this.isExplicitView) {
            if (!this.panelData.accountHandler || !this.panelData.accountHandlerTeam) {
                return 'None Assigned';
            }

            return this._formatPersonsName(
                this.panelData.accountHandler.lastName,
                this.panelData.accountHandler.firstName,
                this.panelData.accountHandlerTeam.name,
            );
        }
        //implicit instance access - show consultant account handler
        else {
            return this._consultingEngagementAccountHandlerTitle;
        }
    }

    get accountHandlerEngagement(): string {
        return this.panelData.accountHandlerEngagement || 'N/A';
    }

    get engagementContacts(): Array<{ abbr: string; name: string }> {
        if (!this.panelData.engagementContacts?.length) return [];

        return this.panelData.engagementContacts.map((c) => {
            const abbr = c.engagementContactType?.abbr ?? '';
            const name = [c.lastName, c.firstName].filter(Boolean).join(', ');
            return { abbr, name };
        });
    }

    async resetAhCode(): Promise<void> {
        const companyId = this.company?.companyID ?? this.topLevelCompanyId;
        if (!companyId) {
            return;
        }

        this.panelData.accountHandlerEngagementOverriden = false;

        try {
            this.panelData.engagementContacts = await this._csrService.getDefaultEngagementContacts(companyId);

            const firstContact = this.panelData.engagementContacts?.[0];
            this.panelData.accountHandlerEngagement = firstContact?.engagement || '';
        } catch {
            this._toastr.error('Unable to load default engagement contacts', 'Error');
        }
    }

    lookupEngagement(): void {
        if (!this._modalService) {
            this._toastr.error('Engagement lookup is unavailable right now.', 'Error');
            return;
        }

        this.bsModalRef = this._modalService.show(EngagementNumberLookupModalComponent, { class: 'modal-lg' });
        this.bsModalRef.content.title = 'Lookup Engagement Number';

        this.bsModalRef.content.onClose = async (engagement: Engagement) => {
            if (!engagement?.engagementID) {
                return;
            }

            this.panelData.accountHandlerEngagement = engagement.engagementID;
            this.panelData.accountHandlerEngagementOverriden = true;

            try {
                this.panelData.engagementContacts = await this._csrService.getEngagementContacts(
                    engagement.engagementID,
                );
            } catch {
                this._toastr.error('Unable to load engagement contacts', 'Error');
            }
        };
    }

    get isAccountHandlerOverridden(): boolean {
        //a subsidiary company/site/parcel cannot override the consultant's account handler
        //the account handler is controlled only through the manage consulting engagement menu

        return this.isExplicitView && this.panelData.accountHandlerIsOverridden;
    }

    get canLaunchHistory(): boolean {
        return (
            !this.editMode &&
            !this.panelLoading &&
            this.entity?.canEditCompanySetups &&
            (!this.isCompany || this.entity?.canEditCompany) &&
            this.entity?.hasWritePermission
        );
    }

    get canEdit(): boolean {
        return (
            !this.editMode &&
            !this.panelLoading &&
            !this.isLongRunningProcessRunning &&
            (!this.isExplicitView ||
                (this.hasEditPermission &&
                    this.entity?.canEditCompanySetups &&
                    (!this.isCompany || this.entity?.canEditCompany) &&
                    this.entity?.hasWritePermission &&
                    (!this.entity?.isInactive || this.isCompany)))
        );
    }

    get canSave(): boolean {
        return (
            this.editMode &&
            (!this.isExplicitView ||
                (this.entity?.canEditCompanySetups &&
                    (!this.isCompany || this.entity?.canEditCompany) &&
                    this.entity?.hasWritePermission))
        );
    }

    get canEditOtherClientServices(): boolean {
        // An inactive company may change its Account Handler without reopening its
        // responsibilities, delivery settings, or engagement configuration.
        return this.editMode && (!this.isExplicitView || !this.isCompany || !this.entity?.isInactive);
    }

    get showJurisdictionSpecialistOption(): boolean {
        return this._userInstanceService.isCurrentInstanceRyan();
    }

    get isConsultingClient(): boolean {
        return (
            this.consultingEngagements.length &&
            this.entityInstanceId &&
            !this._userInstanceService.isInstanceImplicit(this.entityInstanceId)
        );
    }

    async ngOnInit(): Promise<void> {
        const { companyId, siteId, parcelId } = this._router.globals.params;

        this.company = await this._companyService.getCompany(+companyId);

        this.breadcrumbs = [
            {
                name: this.company.companyName,
                target: 'company',
                options: { companyId: this.company.companyID },
            },
        ];

        if (siteId && parcelId) {
            this.isParcel = true;
            const parcelView: Core.ParcelViewDTO = await this._parcelService.getView(+parcelId, true);

            const restrictionData = {
                isCompany: false,
                entityId: parcelView.siteId,
                roles: [],
                flag: Core.AccessRightsEnum.Write,
            };

            const permissions = await this._restrictService.hasPermission(restrictionData);

            this.entity = {
                id: parcelView.parcel.parcelID,
                name: parcelView.parcel.acctNum,
                type: 'parcel',
                typeId: 6,
                newAllowed: false,
                canEditCompanySetups: parcelView.parcel.canEditCompanySetups,
                hasWritePermission: permissions,
                isInactive: parcelView.parcel.activityStatusID === 0,
            };

            this.breadcrumbs.push(
                {
                    name: parcelView.siteName,
                    target: 'site',
                    options: { companyId: this.company.companyID, siteId: parcelView.siteId },
                },
                {
                    name: parcelView.parcel.acctNum,
                    target: 'parcel',
                    options: {
                        companyId: this.company.companyID,
                        siteId: parcelView.siteId,
                        parcelId: parcelView.parcel.parcelID,
                    },
                },
            );
        } else if (siteId) {
            const site = await this._siteService.load(+siteId, this.company.companyID, false, true);

            const restrictionData = {
                isCompany: false,
                entityId: site.siteID,
                flag: Core.AccessRightsEnum.Write,
            };

            const hasWritePermission = await this._restrictService.hasPermission(restrictionData);

            this.entity = {
                type: 'site',
                typeId: EntityTypeIDs.SITE,
                id: site.siteID,
                name: site.name,
                canEditCompanySetups: site.canEditCompanySetups,
                hasWritePermission,
                isInactive: site.activityStatusID === 0,
            };

            this.breadcrumbs.push({
                name: site.name,
                target: 'site',
                options: { companyId: this.company.companyID, siteId: site.siteID },
            });
        } else if (companyId) {
            this.isCompany = true;
            this.isTopLevelCompany = this._companyService.isTopLevel();

            const restrictionData = {
                isCompany: true,
                entityId: this.company.companyID,
                flag: Core.AccessRightsEnum.Write,
            } as RestrictData;

            const hasWritePermission = await this._restrictService.hasPermission(restrictionData);

            this.entity = {
                id: this.company.companyID,
                type: 'company',
                typeId: Core.EntityTypes.Company,
                newAllowed: true,
                name: this.company.companyName,
                canEditCompanySetups: this.company.canEditCompanySetups,
                ppReturnPreparationAllowed: this.company.ppReturnPreparationAllowed,
                isTopLevel: !!this.company.topLevelCompanyId,
                canEditCompany: this.company.canEditCompany,
                isInactive: this.company.activityStatusID === Core.ActivityStatuses.Inactive,
                hasWritePermission,
            };
        }

        const validProcessTypes = [
            Compliance.LongRunningProcessTypeEnum.UpdateCsrBulk,
            Compliance.LongRunningProcessTypeEnum.UpdateCsr,
        ];
        this._websocketListenerService.longRunningProcessStatusChange$
            .pipe(takeUntil(this._destroy$))
            .subscribe(async (x) => {
                if (!validProcessTypes.includes(x.processType) || x.entityId !== this.topLevelCompanyId) {
                    return;
                }
                if (x.isCanceled || x.isError || x.isCompleted) {
                    this.isLongRunningProcessRunning = false;
                    this.panelLoading = true;

                    await this._loadPanel();
                    this.editMode = false;

                    this.panelLoading = false;
                    if (this._busyRef) {
                        await this._busyRef.hide();
                        this._busyRef = null;
                    }
                    this._csrService.notifyClientServicesChange();
                    const lrp = await lastValueFrom(this._longRunningProcessRepository.get(x.longRunningProcessId));
                    if (lrp.result) {
                        const result = JSON.parse(lrp.result);
                        if (result?.result?.companyRowVersion) {
                            this._RowVersionChange(result.result.companyRowVersion);
                        }
                    }
                } else {
                    this.isLongRunningProcessRunning = true;
                }
            });

        await this._loadPanel();

        this._parcelService.refreshCsr$.pipe(takeUntil(this._destroy$)).subscribe(() => this._loadPanel());
    }

    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }

    launchHistoryModal(): void {
        this._changeHistoryModalLaunchService.openChangeHistoryModal(
            this.entity.name,
            this.entity.id,
            this.entity.typeId,
            'CSR',
        );
    }

    async goToEditMode(): Promise<void> {
        this.enteringEditMode = true;
        this.loadingDropdownData = true;

        try {
            const clientServices = await this._csrService.getAll();

            this.availableClientServices = clientServices.filter((x: Weissman.Model.Workflow.ClientService) => {
                const isAllocationsDisabled =
                    x.name === 'Allocations' && !this._featureFlagService.featureFlags.enableAllocationFeature;
                const alreadyHasService = this.panelData.entityClientServices.some(
                    (ecs) => ecs.clientServiceID === x.clientServiceID,
                );
                return !(isAllocationsDisabled || alreadyHasService);
            });

            this.availablePropertyTypes = this._propertyTypes.filter((x) => {
                const responsibilities = this.panelData.entityClientServices[0]?.responsibilities ?? [];
                return !responsibilities.some((r) => r.propertyTypeID === x.propertyTypeID);
            });
        } finally {
            this.loadingDropdownData = false;
        }

        this._originalPPReturnPreparationAllowed = this.entity.ppReturnPreparationAllowed;

        // Deep clone panelData using JSON (data is DTO-like)
        this._originalPanelData = structuredClone(this.panelData);
        this._navigationService.enableNavWarning('Editing is in progress. Are you sure you want to leave?');

        this.ahAvailableUsers = await this._teamService.getAllAssignableUsers(
            false,
            false,
            this.entity.id,
            this.entity.type,
        );

        if (this.isConsultantPerspective) {
            this.csrAvailableUsers = await this._teamService.getAllAssignableUsers(
                false,
                false,
                this.entity.id,
                this.entity.type,
                this.consultantsInstanceId,
            );
        } else {
            this.csrAvailableUsers = this.ahAvailableUsers;
        }

        this.panelData.entityClientServices.forEach((service: EntityClientService) => {
            service.responsibilities.forEach((responsibility: ClientServiceResponsibility) => {
                responsibility.placeholderText = this._getPlaceholderText(responsibility);
            });
        });

        this.enteringEditMode = false;
        this.editMode = true;
    }

    cancelEdit(): void {
        if (this.isTopLevelCompany) {
            this.entity.ppReturnPreparationAllowed = this._originalPPReturnPreparationAllowed;
        }

        this._navigationService.disableNavWarning();
        this.panelData = this._originalPanelData;
        this.editMode = false;
    }

    async savePanel(): Promise<void> {
        if (
            this.panelData.companyIsActive &&
            (!this.panelData.accountHandlerUserID || this.panelData.accountHandlerTeamID == null)
        ) {
            this._toastr.error('Account Handler is required for active companies', 'Error');
            return;
        }

        const panelToSave = {
            accountHandlerUserID: this.panelData.accountHandlerUserID,
            accountHandlerTeamID: this.panelData.accountHandlerTeamID,
            entityID: this.panelData.entityID,
            entityTypeID: this.panelData.entityTypeID,
            companyRowVersion: this.panelData.companyRowVersion,
            accountHandlerEngagement: this.panelData.accountHandlerEngagement,
            accountHandlerEngagementOverriden: this.panelData.accountHandlerEngagementOverriden,
        } as CSRResponsibilitiesDTOIn;

        if (this.isCompany && this.entity.isTopLevel) {
            panelToSave.ppReturnPreparationAllowed = this.entity.ppReturnPreparationAllowed;
        }

        if ((this.isCompany && this.entity.isTopLevel) || this.isParcel) {
            panelToSave.assessmentsTaxFeedEnabled = this.taxFeedSettings.assessmentsTaxFeedsEnabled;
            panelToSave.taxBillsTaxFeedEnabled = this.taxFeedSettings.taxBillsTaxFeedsEnabled;
        }

        const originalResponsibilities = this._originalPanelData.entityClientServices.flatMap(
            (s) => s.responsibilities || [],
        );

        const clonedServices: EntityClientService[] = structuredClone(this.panelData.entityClientServices);
        panelToSave.responsibilities = clonedServices
            .flatMap((s) => s.responsibilities || [])
            .map((resp) => {
                const originalResp = originalResponsibilities.find(
                    (o) => o.clientServiceResponsibilityID === resp.clientServiceResponsibilityID,
                );

                if (!resp.clientServiceResponsibilityID) {
                    resp.efAction = 'add';
                } else if (
                    originalResp &&
                    (originalResp.workflowUserTypeID !== resp.workflowUserTypeID ||
                        originalResp.userID !== resp.userID ||
                        originalResp.teamID !== resp.teamID ||
                        originalResp.consultingEngagementId !== resp.consultingEngagementId ||
                        ((originalResp.dateFrom as any) ?? 0) - ((resp.dateFrom as any) ?? 0) !== 0)
                ) {
                    if (resp.entityID !== this.entity.id) {
                        resp.entityID = this.entity.id;
                        resp.entityTypeID = EntityTypeIds[this.entity.type.toUpperCase()];
                        resp.addingOverride = true;

                        delete resp.isException;
                        delete resp.isTopCompany;
                        delete resp.clientServiceResponsibilityID;

                        resp.efAction = 'add';
                    } else {
                        resp.efAction = 'update';
                    }
                }

                resp.clientService = null;
                resp.assignee = null;
                resp.workflowUserType = null;
                resp.team = null;

                return resp;
            })
            .filter((resp) => !!resp.efAction);

        const editedDeliveryDetails = this._extractDeliveryDetails(this.panelData.entityClientServices);
        const originalDeliveryDetails = this._extractDeliveryDetails(this._originalPanelData.entityClientServices);

        // We now allow an incomplete Payment Batch configuration to be saved, deferring
        // validation to creation of a Payment Batch, so we don't need to ensure the
        // Payment Batch/ configuration is present or feed specifications have been selected.

        let invalidInputFound = editedDeliveryDetails.some((x) => {
            const detail = x as TransmitDeliveryDetail;
            return detail && detail.isMaxPackageSize && (!detail.maxPackageSize || detail.maxPackageSize <= 0);
        });

        if (invalidInputFound) {
            this._toastr.error('Maximum package size value must be greater than 0', 'Error');
            return;
        }

        invalidInputFound = editedDeliveryDetails.some((x) => {
            const detail = x as TransmitDeliveryDetail;
            return (
                detail &&
                detail.isMaxPaymentItems &&
                (!detail.maxPaymentItemsPerTransmittal || detail.maxPaymentItemsPerTransmittal <= 0)
            );
        });

        if (invalidInputFound) {
            this._toastr.error('Maximum payment items per transmittal values must be greater than 0', 'Error');
            return;
        }

        // We need to enforce an upper limit of 1000 on Max Payments per Payment Batch
        // when an Anybill feed spec is configured due to Anybill limitations.
        editedDeliveryDetails.forEach((x) => {
            const detail = x as TransmitDeliveryDetail;
            if (
                detail &&
                detail.transmittalOutputTypeID &&
                detail.transmittalOutputTypeID === TransmittalOutputType.BillPay
            ) {
                const hasAnybillFeedSpec = detail.feedSpecifications.some((feedSpec) => {
                    return feedSpec.feedSpecification.checkFeedProvider == Core.CheckFeedProviderEnum.ProviderAnyBill;
                });

                if (
                    hasAnybillFeedSpec &&
                    (!detail.isMaxPaymentsPerBatch ||
                        !detail.maxPaymentsPerPaymentBatch ||
                        detail.maxPaymentsPerPaymentBatch > 1000)
                ) {
                    detail.isMaxPaymentsPerBatch = true;
                    detail.maxPaymentsPerPaymentBatch = 1000;
                    this._toastr.info(
                        'Maximum payments per Payment Batch set to 1000 to enforce Anybill limitations',
                        'Information',
                    );
                }
            }
        });

        invalidInputFound = editedDeliveryDetails.some((x) => {
            const detail = x as TransmitDeliveryDetail;
            return (
                detail &&
                detail.transmittalOutputTypeID &&
                detail.transmittalOutputTypeID === TransmittalOutputType.BillPay &&
                detail.isMaxPaymentsPerBatch &&
                (!detail.maxPaymentsPerPaymentBatch || detail.maxPaymentsPerPaymentBatch <= 0)
            );
        });

        if (invalidInputFound) {
            this._toastr.error('Maximum payments per Payment Batch value must be greater than 0', 'Error');
            return;
        }

        let removePaymentBatchDataFlag = false;

        const deliveryDetailsToSave = editedDeliveryDetails
            .map((x) => {
                const editedDeliveryDetail = x as TransmitDeliveryDetail;
                let originalDeliveryDetail = this._getOriginalDeliveryDetail(
                    originalDeliveryDetails as TransmitDeliveryDetail[],
                    editedDeliveryDetail,
                );

                if (!originalDeliveryDetail) {
                    // if compliance return or assessment allocation, then editedDeliveryDetail can be null
                    if (this._isComplianceReturns(editedDeliveryDetail) || this._isAllocations(editedDeliveryDetail)) {
                        originalDeliveryDetail = {} as TransmitDeliveryDetail;
                    } else {
                        console.warn('Could not find a matching original delivery detail');
                        return {} as TransmitDeliveryDetail;
                    }
                }

                if (
                    !originalDeliveryDetail.useTopLevelCompanySettings &&
                    editedDeliveryDetail.useTopLevelCompanySettings
                ) {
                    originalDeliveryDetail.efAction = 'delete';

                    const cleaned = { ...originalDeliveryDetail };
                    delete cleaned.isMaxPackageSize;
                    delete cleaned.isMaxPaymentItems;
                    delete cleaned.isOne;
                    delete cleaned.isMaxPaymentsPerBatch;

                    return cleaned;
                }

                // useTopLevelCompanySettings - if original is different from edited
                //
                if (
                    originalDeliveryDetail.useTopLevelCompanySettings &&
                    !editedDeliveryDetail.useTopLevelCompanySettings
                ) {
                    if (editedDeliveryDetail.taxBillDeliveryDetailID !== undefined) {
                        editedDeliveryDetail.taxBillDeliveryDetailID = 0;
                    } else if (editedDeliveryDetail.deliveryDetailAssessmentID !== undefined) {
                        editedDeliveryDetail.deliveryDetailAssessmentID = 0;
                    } else if (editedDeliveryDetail.deliveryDetailBillID !== undefined) {
                        editedDeliveryDetail.deliveryDetailBillID = 0;
                    }

                    editedDeliveryDetail.efAction = 'add';
                } else if (!this._areDeliveryDetailsEqual(originalDeliveryDetail, editedDeliveryDetail)) {
                    if (
                        (originalDeliveryDetail.taxBillDeliveryDetailID === 0 &&
                            editedDeliveryDetail.taxBillDeliveryDetailID === 0) ||
                        this._isObjectEmpty(originalDeliveryDetail)
                    ) {
                        editedDeliveryDetail.efAction = 'add';
                    } else {
                        editedDeliveryDetail.efAction = 'update';
                    }
                }

                // user did not change batch users/ teams, but switched on the whole thing
                //
                if (
                    this._isComplianceReturns(editedDeliveryDetail) &&
                    this._originalPPReturnPreparationAllowed != this.entity.ppReturnPreparationAllowed &&
                    this.isTopLevelCompany // this info can be saved for top-level company only
                ) {
                    editedDeliveryDetail.efAction = editedDeliveryDetail.deliveryDetails_PPBatchReturnsId
                        ? 'update'
                        : 'add';
                }

                // Prepare PP Returns is set to Off, but the panel still creates the detail with all properties empty and efAction = add. This caused PT-3826
                // https://weissmandemo.atlassian.net/browse/PT-3826
                if (
                    this._isComplianceReturns(editedDeliveryDetail) &&
                    !this.entity.ppReturnPreparationAllowed &&
                    editedDeliveryDetail.efAction === 'add'
                ) {
                    editedDeliveryDetail.efAction = null;
                }

                // if an ef action hasn't been determined yet, check the feed specification
                if (
                    !editedDeliveryDetail.efAction &&
                    editedDeliveryDetail.taxBillDeliveryDetailID &&
                    (this._isFeedSpecificationsUpdated(originalDeliveryDetail, editedDeliveryDetail) ||
                        this.paymentBatchData) // need to send feed spec data if payment batch has been updated
                ) {
                    editedDeliveryDetail.efAction = 'update';
                }

                if (
                    originalDeliveryDetail.transmittalOutputTypeID === TransmittalOutputType.BillPay &&
                    editedDeliveryDetail.transmittalOutputTypeID !== TransmittalOutputType.BillPay
                ) {
                    removePaymentBatchDataFlag = true;
                }

                const cleaned = { ...editedDeliveryDetail };
                delete cleaned.isMaxPackageSize;
                delete cleaned.isMaxPaymentItems;
                delete cleaned.isOne;
                delete cleaned.isMaxPaymentsPerBatch;

                return cleaned;
            })
            .filter((d) => !!d.efAction);

        const deliveryGrouped: { [key: string]: TransmitDeliveryDetail[] } = {};
        for (const detail of deliveryDetailsToSave) {
            let key: string;
            if (detail.taxBillDeliveryDetailID !== undefined) {
                key = 'deliveryDetails';
            } else if (detail.deliveryDetailAssessmentID !== undefined) {
                key = 'deliveryDetailAssessments';
            } else if (detail.deliveryDetailBillID !== undefined) {
                key = 'deliveryDetailBills';
            } else if (this._isComplianceReturns(detail)) {
                key = 'DeliveryDetailPPReturnBatches';
            } else if (this._isAllocations(detail)) {
                key = 'deliveryDetailAssessmentAllocation';
            } else {
                key = 'errorNoID';
            }

            if (!deliveryGrouped[key]) {
                deliveryGrouped[key] = [];
            }

            deliveryGrouped[key].push(detail);
        }

        if (
            this.isEntityInRyanInstance &&
            this.isCompany
        ) {
            if (this.paymentBatchData) {
                deliveryGrouped['deliveryDetailPaymentBatch'] = [this.paymentBatchData as any];
            }

            if (removePaymentBatchDataFlag) {
                deliveryGrouped['deliveryDetailPaymentBatch'] = deliveryGrouped.deliveryDetailPaymentBatch || [
                    { ownerEntityID: this.entity.id } as TransmitDeliveryDetail,
                ];
                deliveryGrouped.deliveryDetailPaymentBatch[0].efAction = 'delete';
            }
        }

        Object.assign(panelToSave, deliveryGrouped);

        //Check if all fields that require a date contain the date, otherwise throw toast
        const invalidDate = panelToSave.responsibilities.some((resp) => resp.showDatePicker && !resp.dateFrom);
        if (invalidDate) {
            this._toastr.error('Please fill in all start dates', 'Missing date');
            return;
        }

        //Check invoice tasks under appeals
        const invalidAppeal = panelToSave.responsibilities.some((resp) => {
            return (
                resp.clientServiceID === ClientServiceType.Appeals &&
                resp.workflowUserTypeID === Core.WorkflowUserTypes.NA &&
                resp.hasOpenPrepareDraftInvoiceTasks
            );
        });

        if (invalidAppeal) {
            this._toastr.error(
                'Appeals responsibility can not be set to N/A if there is at least one unfinished "Prepare Draft Invoice" task ',
                'Validation error',
            );
            return;
        }

        if (!this.isTopLevelCompany && panelToSave.DeliveryDetailPPReturnBatches)
            delete panelToSave.DeliveryDetailPPReturnBatches;

        // Prepare PP Return is on, but DeliveryDetailPPReturnBatches is empty because no batch responsibilities have been entered.
        if (
            this.entity.ppReturnPreparationAllowed &&
            !this._originalPPReturnPreparationAllowed &&
            !panelToSave.DeliveryDetailPPReturnBatches
        ) {
            this._toastr.error('Please enter Batch Responsibilities', 'Validation error');
            return;
        }

        if (
            panelToSave.DeliveryDetailPPReturnBatches &&
            panelToSave.DeliveryDetailPPReturnBatches.length &&
            panelToSave.ppReturnPreparationAllowed
        ) {
            if (this._isUserEmpty('batchPreparer', panelToSave.DeliveryDetailPPReturnBatches[0])) {
                this._toastr.error('Please select Batch Preparer', 'Validation error');
                return;
            }

            if (this._isUserEmpty('batchProcessor', panelToSave.DeliveryDetailPPReturnBatches[0])) {
                this._toastr.error('Please select Batch Processor', 'Validation error');
                return;
            }

            if (this._isUserEmpty('batchReviewer', panelToSave.DeliveryDetailPPReturnBatches[0])) {
                this._toastr.error('Please select Batch Reviewer', 'Validation error');
                return;
            }
        }

        this.serverAction = true;

        try {
            const result = await this._csrService.saveEntity(panelToSave);

            if (result.longRunningProcessId) {
                //Show busy indicator
                this._busyRef = this._busyService.show({
                    longRunningProcessId: result.longRunningProcessId,
                    title: 'Updating Client Service Responsibility',
                    canDismiss: true,
                    message: '',
                    captureFocus: true,
                    restoreFocus: true,
                });

                this._busyRef
                    .onDismiss()
                    .pipe(takeUntil(this._busyDestroy$))
                    .subscribe(() => {
                        this._busyRef.hide();
                        this._busyDestroy$.next();
                        this._busyRef = null;
                        this.panelLoading = true;
                    });

                this._navigationService.disableNavWarning();
            } else {
                this.editMode = false;
                this._navigationService.disableNavWarning();
                if (this.isCompany) {
                    this._RowVersionChange(result.companyRowVersion);
                }

                await this._loadPanel();
            }
        } catch (err) {
            if (err) {
                this._toastr.error(err.error.message);
            }
        } finally {
            this.serverAction = false;
        }
    }

    accountHandlerSelected(newAccountHandler: Core.UserTeamModel): void {
        if (newAccountHandler) {
            this.panelData.accountHandlerUserID = newAccountHandler.userID;
            this.panelData.accountHandlerTeamID = newAccountHandler.teamID;
            this.panelData.accountHandlerTeam = {
                name: newAccountHandler.teamName,
                teamID: newAccountHandler.teamID,
            } as Weissman.Model.Workflow.Team;
            this.panelData.accountHandler = {
                efAction: null,
                firstName: newAccountHandler.firstName,
                lastName: newAccountHandler.lastName,
                userID: newAccountHandler.userID,
            };
        } else {
            this.panelData.accountHandlerUserID = null;
            this.panelData.accountHandlerTeamID = null;
            this.panelData.accountHandlerTeam = {} as Weissman.Model.Workflow.Team;
            this.panelData.accountHandler = {} as Core.ContactShortDTO;
        }
    }

    addClientService(): void {
        const serviceToAdd = {
            clientServiceID: this.newClientService.clientServiceID,
            name: this.newClientService.name,
            sequence: this.newClientService.sequence,
        } as EntityClientService;

        const entityResponsibilities = this.panelData.entityClientServices.length
            ? structuredClone(this.panelData.entityClientServices[0].responsibilities)
            : [];

        serviceToAdd.responsibilities = entityResponsibilities.map((resp) => {
            const updated = {
                ...resp,
                ...this._getInitialValues(),
                clientServiceID: this.newClientService.clientServiceID,
            } as ClientServiceResponsibility;

            updated.disabledWorkflowUserTypes = this._getDisabledWorkflowUserTypes(
                {
                    propertyTypeID: updated.propertyTypeID,
                    clientServiceResponsibilityUpdateStatus:
                        Core.ClientServiceResponsibilityUpdateQueueStatusEnum.Created,
                } as ClientServiceResponsibility,
                serviceToAdd,
            );
            updated.translatedWorkflowUserTypeId = this._getTranslatedWorkflowUserTypeId(updated);

            delete updated.workflowUserType;
            delete updated.clientServiceResponsibilityID;

            return updated as ClientServiceResponsibility;
        });

        this.panelData.entityClientServices.push(serviceToAdd);
        this.availableClientServices = this.availableClientServices.filter((s) => s !== this.newClientService);
    }

    addPropertyType(): void {
        const propTypeToAdd = {
            propTypeAbbr: this.newPropertyType.propTypeAbbr,
            propertyTypeID: this.newPropertyType.propertyTypeID,
        } as ClientServiceResponsibility;
        Object.assign(propTypeToAdd, this._getInitialValues());

        this.panelData.entityClientServices = this.panelData.entityClientServices.map((service) => {
            const respToAdd: ClientServiceResponsibility = structuredClone(propTypeToAdd);

            respToAdd.clientServiceID = service.clientServiceID;
            respToAdd.disabledWorkflowUserTypes = this._getDisabledWorkflowUserTypes(
                {
                    propertyTypeID: respToAdd.propertyTypeID,
                    clientServiceResponsibilityUpdateStatus:
                        Core.ClientServiceResponsibilityUpdateQueueStatusEnum.Created,
                } as ClientServiceResponsibility,
                service,
            );
            respToAdd.translatedWorkflowUserTypeId = this._getTranslatedWorkflowUserTypeId(respToAdd);

            //does not have all fields of ClientServiceResponsibility
            service.responsibilities.push(respToAdd as ClientServiceResponsibility);
            return service;
        });

        this.availablePropertyTypes = this.availablePropertyTypes.filter((p) => p !== this.newPropertyType);
    }

    canEditResponsibility(responsibility: ClientServiceResponsibility): boolean {
        return (
            this.canEditOtherClientServices &&
            (responsibility.clientServiceResponsibilityUpdateStatus === null ||
                responsibility.clientServiceResponsibilityUpdateStatus ===
                    Core.ClientServiceResponsibilityUpdateQueueStatusEnum.Errant) &&
            ((!this.isConsultantPerspective && !this.isLicensedDIUser) ||
                (responsibility.consultingEngagementId && responsibility.isMyConsultingCompany))
        );
    }

    showSpecificIndividualUserTeamPicker(responsibility: ClientServiceResponsibility): boolean {
        return (
            responsibility.translatedWorkflowUserTypeId === Core.WorkflowUserTypes.User &&
            this.canEditResponsibility(responsibility)
        );
    }

    showConsultingEngagementsList(responsibility: ClientServiceResponsibility): boolean {
        return (
            responsibility.translatedWorkflowUserTypeId === WorkflowUserTypesUI.ConsultingEngagement &&
            this.canEditResponsibility(responsibility)
        );
    }

    showWorkflowUserTypeOption(userTypeValue: number) {
        switch (userTypeValue) {
            case Core.WorkflowUserTypes.JurisdictionSpecialist:
                return this.isEntityInRyanInstance || this.showJurisdictionSpecialistOption;
            case Core.WorkflowUserTypes.ConsultantAccountHandler:
                return false;
            case WorkflowUserTypesUI.ConsultingEngagement:
                return (
                    this.isConsultingClient &&
                    this.consultingEngagements &&
                    this.consultingEngagements.length &&
                    !this.isConsultantPerspective
                );
            default:
                return true;
        }
    }

    async retryResponsibilityUpdate(responsibility: ClientServiceResponsibility): Promise<void> {
        this._busyRef = this._busyService.show({
            title: 'Retrying task updates',
            canDismiss: true,
            message: '',
            captureFocus: true,
            restoreFocus: true,
        });
        try {
            await this._csrService.retryWorkflowUpdateFromQueue({
                entityTypeId: responsibility.entityTypeID,
                entityId: responsibility.entityID,
                clientServiceId: responsibility.clientServiceID,
                propertyTypeId: responsibility.propertyTypeID,
            });
        } finally {
            await this._busyRef.hide();
            this._busyRef = null;
        }

        responsibility.clientServiceResponsibilityUpdateStatus = null;
    }

    showResponsibilityUpdatingInfoIcon(status: number): boolean {
        return (
            status === Core.ClientServiceResponsibilityUpdateQueueStatusEnum.Created ||
            status === Core.ClientServiceResponsibilityUpdateQueueStatusEnum.Running ||
            status === Core.ClientServiceResponsibilityUpdateQueueStatusEnum.Completed
        );
    }

    showRetryResponsibilityUpdateIcon(status: number): boolean {
        return status === Core.ClientServiceResponsibilityUpdateQueueStatusEnum.Errant;
    }

    userTypeChanged(
        workflowUserTypeId: ClientServicePanelWorkflowUserTypes,
        responsibility: ClientServiceResponsibility,
    ): void {
        const previousWorkflowUserTypeId = responsibility.translatedWorkflowUserTypeId;
        responsibility.translatedWorkflowUserTypeId = workflowUserTypeId;

        switch (responsibility.translatedWorkflowUserTypeId) {
            case WorkflowUserTypesUI.ConsultingEngagement:
                responsibility.workflowUserTypeID = Core.WorkflowUserTypes.ConsultantAccountHandler;
                // Note that there is a select component bound to responsibility.consultingEngagementID when there
                // is more than one consulting engagement; it does not exist when only one is available, so it needs
                // to be populated here
                if (this.consultingEngagements.length === 1) {
                    responsibility.consultingEngagementId = this.consultingEngagements[0].consultingEngagementId;
                }
                break;
            case Core.WorkflowUserTypes.AccountHandler:
                //special handling of account handler when consultant looking at it
                if (this.isConsultantPerspective) {
                    responsibility.workflowUserTypeID = Core.WorkflowUserTypes.ConsultantAccountHandler;
                    responsibility.consultingEngagementId = this.consultingEngagements.find((ce) =>
                        this._userInstanceService.isInstanceExplicit(ce.instanceId),
                    ).consultingEngagementId;
                } else {
                    responsibility.workflowUserTypeID = responsibility.translatedWorkflowUserTypeId;
                    responsibility.consultingEngagementId = null;
                }
                break;
            case Core.WorkflowUserTypes.JurisdictionSpecialist:
                responsibility.workflowUserTypeID = Core.WorkflowUserTypes.JurisdictionSpecialist;

                if (this.isConsultantPerspective) {
                    responsibility.consultingEngagementId = this.consultingEngagements.find((ce) =>
                        this._userInstanceService.isInstanceExplicit(ce.instanceId),
                    ).consultingEngagementId;
                } else {
                    responsibility.consultingEngagementId = null;
                }
                break;
            case Core.WorkflowUserTypes.User:
                //consultant person selected
                if (this.isConsultantPerspective) {
                    responsibility.consultingEngagementId = this.consultingEngagements.find((ce) =>
                        this._userInstanceService.isInstanceExplicit(ce.instanceId),
                    ).consultingEngagementId;
                }
                //client person selected
                else {
                    responsibility.consultingEngagementId = null;
                }

                responsibility.workflowUserTypeID = responsibility.translatedWorkflowUserTypeId;

                if (
                    previousWorkflowUserTypeId === WorkflowUserTypesUI.ConsultingEngagement ||
                    previousWorkflowUserTypeId === Core.WorkflowUserTypes.AccountHandler
                ) {
                    responsibility.userID = null;
                    responsibility.teamID = null;
                    responsibility.team = {} as Weissman.Model.Workflow.Team;
                    responsibility.assignee = {} as Core.ContactShortDTO;
                }
                break;
            //NA selected
            default:
                responsibility.workflowUserTypeID = responsibility.translatedWorkflowUserTypeId;
                if (this.isConsultantPerspective) {
                    responsibility.consultingEngagementId = this.consultingEngagements.find((ce) =>
                        this._userInstanceService.isInstanceExplicit(ce.instanceId),
                    ).consultingEngagementId;
                } else {
                    responsibility.consultingEngagementId = null;
                }
        }

        //changing from NA to another user type
        if (
            previousWorkflowUserTypeId === Core.WorkflowUserTypes.NA &&
            responsibility.workflowUserTypeID !== Core.WorkflowUserTypes.NA
        ) {
            responsibility.showDatePicker = true;
        }
        //changing to NA
        else if (responsibility.workflowUserTypeID === Core.WorkflowUserTypes.NA) {
            responsibility.showDatePicker = false;
            responsibility.dateFrom = null;
        }

        //no specific user
        if (responsibility.workflowUserTypeID !== Core.WorkflowUserTypes.User) {
            responsibility.userID = null;
            responsibility.teamID = null;
            responsibility.team = {} as Weissman.Model.Workflow.Team;
            responsibility.assignee = {} as Core.ContactShortDTO;
        }

        this.panelData.entityClientServices = this.panelData.entityClientServices.map((service) => {
            service.responsibilities = service.responsibilities.map((resp) => {
                resp.disabledWorkflowUserTypes = this._getDisabledWorkflowUserTypes(resp, service);
                return resp;
            });

            return service;
        });

        // Initially seed data from selected consulting engagement (this might not get called otherwise if there's no dropdown)
        if (responsibility.workflowUserTypeID === Core.WorkflowUserTypes.ConsultantAccountHandler) {
            this.changeConsultingEngagement(responsibility);
        }
    }

    showExceptionsLink(status: number): boolean {
        return !(
            this.canEditOtherClientServices &&
            (status === null || status === Core.ClientServiceResponsibilityUpdateQueueStatusEnum.Errant)
        );
    }

    openExceptionsModal(responsibility: ClientServiceResponsibility, service: EntityClientService) {
        this._clientServicesExceptionModalService.openExceptionsModal(
            this.entity.id,
            +EntityTypeIds[this.entity.type.toUpperCase()],
            [service.clientServiceID],
            [responsibility.propertyTypeID],
            this.entity.isInactive,
        );
    }

    specificIndividualSelected(newIndividual: Core.UserTeamModel, responsibility: ClientServiceResponsibility) {
        responsibility.userID = newIndividual.userID;
        responsibility.teamID = newIndividual.teamID;

        responsibility.team = {
            name: newIndividual.teamName,
            teamID: newIndividual.teamID,
        } as Weissman.Model.Workflow.Team;

        responsibility.assignee = {
            efAction: null,
            firstName: newIndividual.firstName,
            lastName: newIndividual.lastName,
            userID: newIndividual.userID,
        };
    }

    changeConsultingEngagement(responsibility: ClientServiceResponsibility): void {
        const engagement = this.consultingEngagements.find(
            (ce) => ce.consultingEngagementId === responsibility.consultingEngagementId,
        );

        responsibility.userID = engagement?.accountHandler?.userId;
        responsibility.teamID = engagement?.accountHandler?.teamId;
    }

    isTaxFeedToggleEnabled(topLevelTaxFeedSetting: boolean): boolean {
        return (
            (this.isTopLevelCompany && this.hasTaxFeeds) ||
            (this.isParcel && this.canEditCompany && topLevelTaxFeedSetting)
        );
    }

    private _getInitialValues(): ClientServiceResponsibility {
        return {
            teamID: null,
            userID: null,
            assignee: {},
            team: {},
            workflowUserTypeID: Core.WorkflowUserTypes.NA,
            propertyTypeXServiceHasChildExceptions: false,
            entityID: this.entity.id,
            entityTypeID: EntityTypeIds[this.entity.type.toUpperCase()],
            isException: !this.isTopLevelCompany,
        } as ClientServiceResponsibility;
    }

    private async _loadPanel(): Promise<void> {
        this.panelLoading = true;

        this.paymentBatchData = undefined;
        this._propertyTypes = this._constants.propertyTypeArr();

        try {
            const [aeEntityTypeId, aeEntityId] = this.company
                ? [EntityTypeIds.COMPANY, this.company.topLevelCompanyId]
                : [this.entity.typeId, this.entity.id];

            [this.consultingEngagements, this.panelData, this.entityInstanceId, this.entityTree, this.taxFeedSettings] =
                await Promise.all([
                    this._consultingEngagementsRepository.getAcceptedEngagements(aeEntityTypeId, aeEntityId),
                    this._csrService.getByEntity(this.entity),
                    lastValueFrom(this._instanceRepository.getEntityInstanceId(this.entity.type, this.entity.id)),
                    this._processingService.getEntityTree(this.entity.typeId, this.entity.id, false),
                    lastValueFrom(this._taxFeedSettingRepository.getByEntity(this.entity.id, this.entity.typeId)),
                ]);

            this.topLevelCompanyId = this.entityTree.topLevelCompany
                ? this.entityTree.topLevelCompany.entityId
                : this.entityTree.subsidiaryCompany.entityId;

            this.isEntityInRyanInstance = this.entityInstanceId === RyanInstanceId;

            if (this.entity.typeId === Core.EntityTypes.Parcel) {
                this.topLevelCompanyTaxFeedSettings = await lastValueFrom(
                    this._taxFeedSettingRepository.getByEntity(this.topLevelCompanyId, Core.EntityTypes.Company),
                );
            }
            const currentlyRunningUpdates = await lastValueFrom(
                this._longRunningProcessRepository.getList({
                    columnFilters: [
                        {
                            filterProperty: Compliance.LongRunningProcessPropertyEnum.EntityId,
                            filterConditionType: Core.FilterConditionTypeEnum.And,
                            filterValues: [
                                {
                                    filterType: Core.FilterTypeEnum.Equals,
                                    filterValue: this.topLevelCompanyId.toString(),
                                },
                            ],
                        },
                        {
                            filterProperty: Compliance.LongRunningProcessPropertyEnum.LongRunningProcessTypeName,
                            filterConditionType: Core.FilterConditionTypeEnum.And,
                            filterValues: [{ filterType: Core.FilterTypeEnum.EndsWith, filterValue: 'Update CSR' }],
                        },
                        {
                            filterProperty: Compliance.LongRunningProcessPropertyEnum.End,
                            filterConditionType: Core.FilterConditionTypeEnum.And,
                            filterValues: [{ filterType: Core.FilterTypeEnum.Blank, filterValue: '' }],
                        },
                    ],
                    pagination: {
                        noPagination: true,
                    },
                    allUsers: true,
                    notAcknowledged: true,
                }),
            );

            this.isLongRunningProcessRunning = !!currentlyRunningUpdates.totalRows;
            this.hasEditPermission = this._restrictService.hasInstanceRight(
                InstanceRights.PRIVATEITEMSEDIT,
                this.entityInstanceId,
            );
            this.hasComplianceFeatureView = this._restrictService.hasInstanceRight(
                InstanceRights.COMPLIANCEFEATURESVIEW,
                this.entityInstanceId,
            );
            this.isExplicitView = !this._userInstanceService.isCrossInstancePerspective(this.entityInstanceId);
            this.isConsultantPerspective = this._userInstanceService.isCrossInstancePerspective(this.entityInstanceId);
            this.hasTaxFeeds = this._restrictService.hasInstanceRight(InstanceRights.ALLOWTAXFEEDS);
            this.canEditCompany = await this._restrictService.hasCompanyPermission(
                this.topLevelCompanyId,
                Core.AccessRightsEnum.Write,
            );

            if (this.entityInstanceId !== RyanInstanceId) {
                const instanceInfo = await lastValueFrom(this._instanceRepository.get(this.entityInstanceId));

                if (instanceInfo && instanceInfo.documentIntakeAndProcessingAssignToRyan) {
                    const responses = await Promise.all([
                        lastValueFrom(this._documentIntakeLicensedClientRepository.get(this.entityInstanceId)),
                        this._userGroupService.getForMember(this._userService.getUser().id),
                    ]);
                    this._instanceLicensedDISettings = responses[0];
                    const userGroups = responses[1];

                    this.isLicensedDIUser =
                        this._instanceLicensedDISettings &&
                        this._instanceLicensedDISettings.ryanUserGroupId &&
                        userGroups.some((x) => x.groupID === this._instanceLicensedDISettings.ryanUserGroupId);
                }
            }

            if (!this.isExplicitView) {
                const ce = this.consultingEngagements.find(
                    (x) => x.instanceId === this._userInstanceService.getSelectedInstance().instanceId,
                );
                if (ce) {
                    this._consultingEngagementAccountHandlerTitle = this._formatPersonsName(
                        ce.accountHandler.lastName,
                        ce.accountHandler.firstName,
                        ce.accountHandler.teamName,
                    );
                }
            }

            if (this.isConsultantPerspective) {
                const ce = this.consultingEngagements.find((x) =>
                    this._userInstanceService.isInstanceExplicit(x.instanceId),
                );

                if (ce) {
                    this.consultantsInstanceId = ce.instanceId;
                } else {
                    this.consultantsInstanceId = this.entityInstanceId;
                    this.isConsultantPerspective = false;
                }
            }

            this.currentInstanceId = this.isConsultantPerspective ? this.consultantsInstanceId : this.entityInstanceId;

            this.panelData.entityClientServices = this.panelData.entityClientServices
                .map((service: EntityClientService) => {
                    service.responsibilities = (service.responsibilities || [])
                        .map((resp: ClientServiceResponsibility) => {
                            const propType = this._propertyTypes.find(
                                (pt) => pt.propertyTypeID === resp.propertyTypeID,
                            );
                            resp.propTypeAbbr = propType?.propTypeAbbr;

                            resp.isException = this._getIsException(resp);
                            resp.customerHasChildExceptions = this._getHasChildExceptions(resp);
                            resp.isMyConsultingCompany = this._getIsMyConsultingCompany(resp);
                            resp.assigneeDisplay = this._getAssigneeDisplay(resp);
                            resp.translatedWorkflowUserTypeId = this._getTranslatedWorkflowUserTypeId(resp);
                            resp.disabledWorkflowUserTypes = this._getDisabledWorkflowUserTypes(resp, service);

                            return resp;
                        })
                        .sort((a, b) => (a.propertyTypeID ?? 0) - (b.propertyTypeID ?? 0));

                    return service;
                })
                .sort((a, b) => (a.sequence ?? 0) - (b.sequence ?? 0));
        } finally {
            this.panelLoading = false;
        }
    }

    private _getIsException(responsibility: ClientServiceResponsibility): boolean {
        if (
            !this._userInstanceService.isInstanceImplicit(this.entityInstanceId) &&
            responsibility.consultingEngagementId
        ) {
            return responsibility.customerIsException;
        }

        return responsibility.isException;
    }

    private _getHasChildExceptions(responsibility: ClientServiceResponsibility): boolean {
        if (
            !this._userInstanceService.isInstanceImplicit(this.entityInstanceId) &&
            responsibility.consultingEngagementId
        ) {
            return responsibility.customerHasChildExceptions;
        }

        return responsibility.propertyTypeXServiceHasChildExceptions;
    }

    private _getIsMyConsultingCompany(responsibility: ClientServiceResponsibility): boolean {
        if (
            !responsibility.consultingEngagementId ||
            this.consultingEngagements.length == 0 ||
            !this.isConsultantPerspective
        ) {
            return false;
        }

        const consultingEngagement = this.consultingEngagements.find(
            (ce) => ce.consultingEngagementId === responsibility.consultingEngagementId,
        );
        return this._userInstanceService.isInstanceExplicit(consultingEngagement.instanceId);
    }

    private _getAssigneeDisplay(responsibility: ClientServiceResponsibility): string {
        const workflowUserTypeId = this._lookupWorkflowUserType(responsibility.workflowUserTypeID).value;

        //user is consultant and is looking at company they are consulting on
        if (this.isConsultantPerspective && workflowUserTypeId == Core.WorkflowUserTypes.AccountHandler) {
            return 'Client Account Handler';
        }

        //responsibility is part of a consulting engagement (consultant responsibility)
        if (responsibility.consultingEngagementId && this.consultingEngagements.length > 0) {
            //client perspective or assigned to different consulting company
            if (!this.isConsultantPerspective || !responsibility.isMyConsultingCompany) {
                //look up engagement
                const engagement = this.consultingEngagements.find(
                    (ce) => ce.consultingEngagementId === responsibility.consultingEngagementId,
                );

                if (engagement) {
                    return `Consultant- ${engagement.name}`;
                }

                return 'Loading...';
            }
        }

        return this._getResponsibilityLabel(responsibility, workflowUserTypeId);
    }

    private _getPlaceholderText(responsibility: ClientServiceResponsibility): string {
        const csrUser = this.csrAvailableUsers.find((u) => u.userID === responsibility.userID);
        const ahUser = this.ahAvailableUsers.find((u) => u.userID === responsibility.userID);
        const userType = this._lookupWorkflowUserType(responsibility.workflowUserTypeID);

        if (
            responsibility.assigneeDisplay &&
            responsibility.userID &&
            responsibility.teamID &&
            userType.value != Core.WorkflowUserTypes.ConsultantAccountHandler &&
            !csrUser &&
            (!ahUser || this.isConsultantPerspective)
        ) {
            return `${responsibility.assigneeDisplay} INACTIVE`;
        } else {
            return null;
        }
    }

    private _lookupWorkflowUserType(workflowUserTypeId: number): { value: number; name: string } {
        return this.workflowUserTypes.find((x) => x.value == workflowUserTypeId); //lodash find may be faster
    }

    private _getResponsibilityLabel(responsibility: ClientServiceResponsibility, workflowUserTypeId: number): string {
        if (workflowUserTypeId == Core.WorkflowUserTypes.User) {
            const hasAssignee = responsibility.assignee && Object.keys(responsibility.assignee).length > 0;
            const hasTeam = responsibility.team && Object.keys(responsibility.team).length > 0;

            if (hasAssignee && hasTeam) {
                return this._formatPersonsName(
                    responsibility.assignee.lastName,
                    responsibility.assignee.firstName,
                    responsibility.team.name,
                );
            }
            //I'm unsure of what should happen if the responsibility is assigned to a user, but there is no assignee and team on the responsibility
        } else {
            return this._lookupWorkflowUserType(workflowUserTypeId).name;
        }
    }

    private _getTranslatedWorkflowUserTypeId(responsibility: ClientServiceResponsibility): number {
        if (
            this.isConsultantPerspective &&
            responsibility.workflowUserTypeID === Core.WorkflowUserTypes.ConsultantAccountHandler
        ) {
            return Core.WorkflowUserTypes.AccountHandler;
        }

        if (responsibility.consultingEngagementId && !this.isConsultantPerspective && this.isConsultingClient) {
            return WorkflowUserTypesUI.ConsultingEngagement;
        }

        return responsibility.workflowUserTypeID;
    }

    private _checkIfNASelected(service: EntityClientService, propertyTypeId: number): boolean {
        return !!service?.responsibilities?.some(
            (r) => r.propertyTypeID === propertyTypeId && r.workflowUserTypeID === Core.WorkflowUserTypes.NA,
        );
    }

    private _checkServiceHasUserSelected(clientServiceId: number, propertyTypeId: number): boolean {
        const service = this.panelData.entityClientServices.find((x) => x.clientServiceID === clientServiceId);
        return !!service && !this._checkIfNASelected(service, propertyTypeId);
    }

    private _getDisabledWorkflowUserTypes(
        clientServiceResponsibility: ClientServiceResponsibility,
        service: EntityClientService,
    ): ClientServicePanelWorkflowUserTypes[] {
        let rslt = [];
        switch (service.clientServiceID) {
            case ClientServiceType.ComplianceReturns:
                rslt = this._getComplianceReturnsDisabledWorkflowUserTypes(clientServiceResponsibility.propertyTypeID);
                break;
            case ClientServiceType.Assessments:
                rslt = this._getAssessmentsDisabledWorkflowUserTypes(clientServiceResponsibility.propertyTypeID);
                break;
            case ClientServiceType.TaxBills:
                rslt = this._getTaxBillsDisabledWorkflowUserTypes(clientServiceResponsibility.propertyTypeID);
                break;
            case ClientServiceType.TaxBillTransmit:
                rslt = this._getTaxBillTransmitDisabledWorkflowUserTypes(clientServiceResponsibility.propertyTypeID);
                break;
            case ClientServiceType.Appeals:
                rslt = this._getAppealsDisabledWorkflowUserTypes(clientServiceResponsibility.propertyTypeID);
                break;
            case ClientServiceType.Allocation:
                rslt = this._getAllocationDisabledWorkflowUserTypes(clientServiceResponsibility.propertyTypeID);
                break;
        }

        if (
            clientServiceResponsibility?.clientServiceResponsibilityUpdateStatus ==
            Core.ClientServiceResponsibilityUpdateQueueStatusEnum.Errant
        ) {
            rslt = rslt.concat([
                Core.WorkflowUserTypes.AccountHandler,
                Core.WorkflowUserTypes.ConsultantAccountHandler,
                WorkflowUserTypesUI.ConsultingEngagement,
                Core.WorkflowUserTypes.JurisdictionSpecialist,
                Core.WorkflowUserTypes.User,
            ]);
        }

        if (this.isConsultantPerspective) {
            rslt = rslt.concat([Core.WorkflowUserTypes.NA]);
        }

        return rslt;
    }

    private _getComplianceReturnsDisabledWorkflowUserTypes(
        propertyTypeId: number,
    ): ClientServicePanelWorkflowUserTypes[] {
        const hasAllocationUser = this._checkServiceHasUserSelected(ClientServiceType.Allocation, propertyTypeId);

        return hasAllocationUser ? [Core.WorkflowUserTypes.NA] : [];
    }

    private _getTaxBillTransmitDisabledWorkflowUserTypes(
        propertyTypeId: number,
    ): ClientServicePanelWorkflowUserTypes[] {
        const hasTaxBillUser = this._checkServiceHasUserSelected(ClientServiceType.TaxBills, propertyTypeId);

        return !hasTaxBillUser
            ? [
                  Core.WorkflowUserTypes.AccountHandler,
                  Core.WorkflowUserTypes.JurisdictionSpecialist,
                  Core.WorkflowUserTypes.User,
                  WorkflowUserTypesUI.ConsultingEngagement,
              ]
            : [];
    }

    private _getTaxBillsDisabledWorkflowUserTypes(propertyTypeId: number): ClientServicePanelWorkflowUserTypes[] {
        const hasTaxBillTransmitUser = this._checkServiceHasUserSelected(
            ClientServiceType.TaxBillTransmit,
            propertyTypeId,
        );
        const hasAssessmentsUser = this._checkServiceHasUserSelected(ClientServiceType.Assessments, propertyTypeId);

        if (!hasAssessmentsUser) {
            return [
                Core.WorkflowUserTypes.AccountHandler,
                Core.WorkflowUserTypes.JurisdictionSpecialist,
                Core.WorkflowUserTypes.User,
                WorkflowUserTypesUI.ConsultingEngagement,
            ];
        }

        //an assessments workflow user must be set to be able to have a tax bill transmit user set
        if (hasAssessmentsUser && hasTaxBillTransmitUser) {
            return [Core.WorkflowUserTypes.NA];
        }

        return [];
    }

    private _getAllocationDisabledWorkflowUserTypes(propertyTypeId: number): ClientServicePanelWorkflowUserTypes[] {
        const hasComplianceUser = this._checkServiceHasUserSelected(
            ClientServiceType.ComplianceReturns,
            propertyTypeId,
        );
        const hasAssessmentsUser = this._checkServiceHasUserSelected(ClientServiceType.Assessments, propertyTypeId);

        const canAssignPPWorkflowUser =
            propertyTypeId == PropertyType.Personal && hasComplianceUser && hasAssessmentsUser;

        return propertyTypeId != PropertyType.Personal || !canAssignPPWorkflowUser
            ? [
                  Core.WorkflowUserTypes.AccountHandler,
                  Core.WorkflowUserTypes.JurisdictionSpecialist,
                  Core.WorkflowUserTypes.User,
                  WorkflowUserTypesUI.ConsultingEngagement,
                  Core.WorkflowUserTypes.ConsultantAccountHandler,
              ]
            : [];
    }

    private _getAssessmentsDisabledWorkflowUserTypes(propertyTypeId: number): ClientServicePanelWorkflowUserTypes[] {
        const hasAppealsUser = this._checkServiceHasUserSelected(ClientServiceType.Appeals, propertyTypeId);
        const hasTaxBillsUser = this._checkServiceHasUserSelected(ClientServiceType.TaxBills, propertyTypeId);
        const hasAllocationsUser = this._checkServiceHasUserSelected(ClientServiceType.Allocation, propertyTypeId);

        return hasAppealsUser || hasTaxBillsUser || hasAllocationsUser ? [Core.WorkflowUserTypes.NA] : [];
    }

    private _getAppealsDisabledWorkflowUserTypes(propertyTypeId: number): ClientServicePanelWorkflowUserTypes[] {
        const hasAssessmentsUser = this._checkServiceHasUserSelected(ClientServiceType.Assessments, propertyTypeId);

        return !hasAssessmentsUser
            ? [
                  Core.WorkflowUserTypes.AccountHandler,
                  Core.WorkflowUserTypes.JurisdictionSpecialist,
                  Core.WorkflowUserTypes.User,
                  WorkflowUserTypesUI.ConsultingEngagement,
              ]
            : [];
    }

    private _extractDeliveryDetails(
        entityClientServices: EntityClientService[],
    ): (
        | TransmitDeliveryDetail
        | DRTeamRetrievesDeliveryDetail
        | ComplianceDeliveryDetail
        | DRTeamRetrievesWPDeliveryDetail
    )[] {
        return entityClientServices
            .flatMap((x) => [
                x.taxBillDeliveryDetailsCurrent,
                x.deliveryDetailAssessmentCurrent,
                x.deliveryDetailBillCurrent,
                x.deliveryDetailPPReturnBatchCurrent,
                x.deliveryDetailAssessmentAllocationTop,
            ])
            .filter((x) => x)
            .filter((x) => !this._isObjectEmpty(x));
    }

    private _isFeedSpecificationsUpdated(
        { feedSpecifications: originalFeedSpecs },
        { feedSpecifications: editedFeedSpecs },
    ): boolean {
        if (originalFeedSpecs && editedFeedSpecs) {
            if (originalFeedSpecs.length !== editedFeedSpecs.length) {
                return true;
            } else {
                return originalFeedSpecs.some(
                    (x: DeliveryDetailFeedSpecification, i: number) =>
                        x.feedSpecificationID !== editedFeedSpecs[i].feedSpecificationID ||
                        x.includedInEmail !== editedFeedSpecs[i].includedInEmail,
                );
            }
        } else {
            return true;
        }
    }

    private _isUserEmpty(prefix: string, userObj: Core.ContactShortDTO): boolean {
        return !(userObj[`${prefix}UserId`] && userObj[`${prefix}UserId`] != EmptyGuid);
    }

    private _getOriginalDeliveryDetail(
        originalDeliveryDetails: TransmitDeliveryDetail[],
        editedDeliveryDetail: TransmitDeliveryDetail,
    ): TransmitDeliveryDetail {
        if (editedDeliveryDetail.taxBillDeliveryDetailID !== undefined) {
            return originalDeliveryDetails.find(
                (o) => o.taxBillDeliveryDetailID === editedDeliveryDetail.taxBillDeliveryDetailID,
            );
        }
        if (editedDeliveryDetail.deliveryDetailAssessmentID !== undefined) {
            return originalDeliveryDetails.find(
                (o) => o.deliveryDetailAssessmentID === editedDeliveryDetail.deliveryDetailAssessmentID,
            );
        }
        if (editedDeliveryDetail.deliveryDetailBillID !== undefined) {
            return originalDeliveryDetails.find((item) => item.deliveryDetailBillID !== undefined);
        }

        if (this._isComplianceReturns(editedDeliveryDetail)) {
            return originalDeliveryDetails.find((x) => this._isComplianceReturns(x));
        }

        if (this._isAllocations(editedDeliveryDetail)) {
            return originalDeliveryDetails.find((x) => this._isAllocations(x));
        }

        return undefined;
    }

    private _isComplianceReturns(clientService: TransmitDeliveryDetail | ClientServiceResponsibility): boolean {
        if ((clientService as TransmitDeliveryDetail).deliveryDetails_PPBatchReturnsId) {
            return true;
        }

        const keys = Object.keys(clientService).filter((key) => key !== 'efAction');
        const prefixKey = keys.find((key) => key !== 'efAction');

        return !!prefixKey && prefixKey.startsWith(this.COMPLIANCE_PREFIX);
    }

    private _isAllocations(clientService: TransmitDeliveryDetail | ClientServiceResponsibility): boolean {
        if ('drTeamRetrievesWP' in clientService) {
            return true;
        }

        const keys = Object.keys(clientService).filter((key) => key !== 'efAction');
        const prefixKey = keys.find((key) => key !== 'efAction');

        return !!prefixKey && prefixKey.startsWith(this.ALLOCATIONS_PREFIX);
    }

    private _RowVersionChange(newRowVersion: number[]): void {
        if (this.panelData) {
            this.panelData.companyRowVersion = newRowVersion;
        }
    }

    private _formatPersonsName(lastName: string, firstName: string, teamName: string): string {
        return `${lastName}, ${firstName}  (${teamName})`;
    }

    private _areDeliveryDetailsEqual(a: TransmitDeliveryDetail, b: TransmitDeliveryDetail): boolean {
        const aKeys = Object.keys(a || {});
        const bKeys = Object.keys(b || {});
        if (aKeys.length !== bKeys.length) {
            return false;
        }

        return aKeys.every((key) => a[key] === b[key]);
    }

    private _isObjectEmpty(obj: any): boolean {
        return !obj || Object.keys(obj).length === 0;
    }
}
